import styled from "styled-components";
import { COLORS } from "../../../values/colors";

export const HeroBanner = styled.div`
  width: min(1200px, calc(100% - 3rem));
  box-sizing: border-box;
  margin: 8rem auto 3rem;
  padding: 3rem;
  border: 1px solid rgba(155, 207, 103, 0.28);
  border-radius: 2rem;
  background:
    radial-gradient(circle at top right, rgba(155, 207, 103, 0.12), transparent 32%),
    linear-gradient(135deg, rgba(10, 12, 10, 0.98), rgba(5, 6, 5, 0.96));
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);

  @media (max-width: 768px) {
    width: calc(100% - 2rem);
    margin-top: 6rem;
    padding: 2rem 1.25rem;
  }
`;

export const Eyebrow = styled.p`
  margin: 0 0 0.75rem;
  color: #9bcf67;
  text-transform: uppercase;
  letter-spacing: 0.18rem;
  font-size: 0.85rem;
`;

export const HeroTitle = styled.h1`
  margin: 0;
  font-size: clamp(2rem, 4vw, 4rem);
  color: ${COLORS.white};
`;

export const HeroText = styled.p`
  max-width: 44rem;
  margin: 1rem 0 0;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.7;
  font-size: 1.02rem;
`;

export const ContentContainer = styled.div`
  width: min(1200px, calc(100% - 3rem));
  margin: 0 auto 5rem;
  display: grid;
  gap: 1.5rem;

  @media (max-width: 768px) {
    width: calc(100% - 2rem);
  }
`;

export const NoticeCard = styled.section`
  border-radius: 1.5rem;
  padding: 1.35rem 1.5rem;
  background: linear-gradient(180deg, rgba(19, 19, 19, 0.98), rgba(12, 12, 12, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: ${COLORS.white};
`;

export const NoticeTitle = styled.h2`
  margin: 0 0 0.45rem;
  font-size: 1.2rem;
`;

export const NoticeText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.6;
`;

export const UserCard = styled.section`
  display: grid;
  gap: 1rem;
  padding: 1.5rem;
  border-radius: 1.5rem;
  background: linear-gradient(180deg, rgba(19, 19, 19, 0.98), rgba(12, 12, 12, 0.95));
  border: 1px solid rgba(155, 207, 103, 0.28);
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.24);
`;

export const UserHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;

  @media (max-width: 720px) {
    flex-direction: column;
  }
`;

export const UserTitle = styled.h2`
  margin: 0;
  font-size: 1.35rem;
`;

export const UserSubline = styled.p`
  margin: 0.35rem 0 0;
  color: rgba(255, 255, 255, 0.62);
`;

export const BadgeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
`;

export const RoleBadge = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.45rem 0.8rem;
  background: rgba(155, 207, 103, 0.12);
  border: 1px solid rgba(155, 207, 103, 0.26);
  color: #d6f0ae;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

export const StatusBadge = styled(RoleBadge)`
  background: rgba(127, 179, 255, 0.12);
  border-color: rgba(127, 179, 255, 0.26);
  color: #d6e6ff;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

export const FieldLabel = styled.span`
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.62);
`;

export const Input = styled.input`
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0.9rem;
  background: rgba(255, 255, 255, 0.04);
  color: ${COLORS.white};
  padding: 0.8rem 0.9rem;
  font-size: 0.96rem;
`;

export const Select = styled.select`
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0.9rem;
  background: rgba(255, 255, 255, 0.04);
  color: ${COLORS.white};
  padding: 0.8rem 0.9rem;
  font-size: 0.96rem;

  option {
    color: black;
  }
`;

export const PasswordRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.75rem;
  align-items: end;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

export const Button = styled.button<{ $variant?: "primary" | "ghost" | "danger" }>`
  border-radius: 999px;
  padding: 0.75rem 1.15rem;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid
    ${({ $variant }) =>
      $variant === "danger" ? "rgba(255, 130, 130, 0.28)" : $variant === "ghost" ? "rgba(255,255,255,0.14)" : "rgba(155, 207, 103, 0.28)"};
  background: ${({ $variant }) =>
    $variant === "danger"
      ? "rgba(138, 32, 32, 0.18)"
      : $variant === "ghost"
        ? "rgba(255,255,255,0.03)"
        : "linear-gradient(135deg, #9bcf67 0%, #6ba743 100%)"};
  color: ${({ $variant }) => ($variant === "primary" ? "#081007" : $variant === "danger" ? "#ffd3d3" : COLORS.white)};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Message = styled.p<{ $tone?: "error" | "success" }>`
  margin: 0;
  color: ${({ $tone }) => ($tone === "error" ? "#ffb4b4" : $tone === "success" ? "#b9ee9d" : "rgba(255,255,255,0.72)")};
`;
